import { formatUsd } from '@pkg/utils';

import { type Prize } from '@app/client/common/structs';

import {
    LeaderboardDataChipType,
    LeaderboardDataChipVariant,
    type LeaderboardItemProps,
    LeaderboardPercentVariant,
    LeaderboardRankVariant,
} from '../types';

type ItemIdVariant = 'primary' | 'secondary' | 'callout';

export const FANTASY_BUDGET = 150000;

export function getItemId(uniqueKey: string, variant: ItemIdVariant = 'primary') {
    return ['Leaderboard', 'Item', variant, uniqueKey].join('_');
}

export function getIsWinningLineup(playerRank: LeaderboardItemProps['rank'], prizes?: Prize[]) {
    return prizes ? prizes.some((prize) => prize.rank === playerRank) : playerRank === 1;
}

export function valueToPercentVariant(value = 0) {
    if (value > 0) return LeaderboardPercentVariant.Positive;
    if (value < 0) return LeaderboardPercentVariant.Negative;

    return LeaderboardPercentVariant.Neutral;
}

export function percentToDataChipVariant(value: LeaderboardPercentVariant) {
    if (value === LeaderboardPercentVariant.Positive) {
        return LeaderboardDataChipVariant.Positive;
    }

    if (value === LeaderboardPercentVariant.Negative) {
        return LeaderboardDataChipVariant.Negative;
    }

    return LeaderboardDataChipVariant.Neutral;
}

export function valueToRankVariant(value = 0, max?: number) {
    const minValue = Math.max(0, value);

    if (minValue === 1) return LeaderboardRankVariant.Gold;
    if (minValue === 2) return LeaderboardRankVariant.Silver;
    if (minValue === 3) return LeaderboardRankVariant.Bronze;
    if (minValue === 69) return LeaderboardRankVariant.Sexy;
    if (minValue === max) return LeaderboardRankVariant.Last;

    return LeaderboardRankVariant.Default;
}

export function formatDataChipValue(value: number, type = LeaderboardDataChipType.Number) {
    if (type === LeaderboardDataChipType.Date) {
        // TODO: We want this in a different format.
        return new Date(value).toLocaleString();
    }

    if (type === LeaderboardDataChipType.Usd) {
        return formatUsd(value, true);
    }

    return value.toLocaleString();
}
